import trace from '~/lib/trace';
import React, {useEffect, useState} from 'react';
import {ScrollView} from 'react-native';
import {Divider} from 'react-native-paper';

import sy from '~/styles';
import {dealer as dealerApi} from '~/api/private';
import {
  Pressable,
  RadioButton,
  ActionButton,
  PrivateText,
} from '~/components/controls';
import Actionsheet, {
  Title,
  Content,
  Actions,
} from '~/components/controls/Actionsheet';
import withDimensions from '~/components/hoc/with-dimensions';
import PropTypes from 'prop-types';

const HEADER_HEIGHT_IN_PX = 70;
const FOOTER_HEIGHT_IN_PX = 50;
const DIVIDER_HEIGHT_IN_PX = 1;

const DealerUserActionsheet = ({
  dimensions,
  visible,
  dealer_id,
  assigned_user_id,
  onDismiss,
  onOK,
}) => {
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState(assigned_user_id ?? null);

  useEffect(() => {
    const fetch = async () => {
      const result = await dealerApi.users(dealer_id);
      setUsers(result);
      setLoading(false);
    };

    fetch().catch(trace);
  }, [dealer_id]);

  if (loading) {
    return <></>;
  }

  return (
    <Actionsheet visible={visible} onDismiss={onDismiss}>
      <Title>Gebruiker opdracht</Title>
      <Divider style={sy['bg-gray88']} />
      <Content style={[sy['pb-0']]}>
        <ScrollView
          contentContainerStyle={{
            maxHeight:
              dimensions.window.height -
              HEADER_HEIGHT_IN_PX -
              DIVIDER_HEIGHT_IN_PX -
              FOOTER_HEIGHT_IN_PX -
              DIVIDER_HEIGHT_IN_PX,
          }}>
          {!loading && (
            <>
              {[{id: null, name: 'Niet toegewezen'}, ...users].map(
                (user, index, arr) => (
                  <React.Fragment key={user.id}>
                    <Pressable
                      style={[
                        sy['py-4'],
                        sy['gap-4'],
                        sy['flex-row'],
                        sy['items-center'],
                      ]}
                      onPress={() => setSelected(user.id)}>
                      <RadioButton checked={selected === user.id} />
                      <PrivateText>{user.name}</PrivateText>
                    </Pressable>
                    {index < arr.length - 1 && (
                      <Divider style={sy['bg-gray88']} />
                    )}
                  </React.Fragment>
                ),
              )}
            </>
          )}
        </ScrollView>
      </Content>
      <Divider style={sy['bg-gray88']} />
      <Actions>
        <ActionButton onPress={onDismiss}>Annuleren</ActionButton>
        <ActionButton onPress={() => onOK(selected)}>OK</ActionButton>
      </Actions>
    </Actionsheet>
  );
};
DealerUserActionsheet.propTypes = {
  dimensions: PropTypes.any,
  visible: PropTypes.any,
  dealer_id: PropTypes.any,
  assigned_user_id: PropTypes.any,
  onDismiss: PropTypes.any,
  onOK: PropTypes.any,
};

export default withDimensions(DealerUserActionsheet);
